import * as React from "react";
import { IInvestigatorInPlay } from "./Scenario";
import { Dnd, IDragSource } from "./Dnd";
import { CardToolbarComponent } from "./CardToolbarComponent";
import { IDeckToolbarSettings, Deck } from "./Deck";
import { CardUtil } from "./CardUtil";

export interface IInvestigatorPortraitSource {

}
export interface IInvestigatorPortraitProps {
    investigator: IInvestigatorInPlay;
    index: number;
    disableToolbar?: boolean;
    disableDrag?: boolean;
    onChanged: () => void;
}
export class InvestigatorPortraitComponent extends React.Component<IInvestigatorPortraitProps, any> implements IDragSource {
    static dragType: string = "card/investigator";

    private readonly deck: Deck;
    constructor(props: IInvestigatorPortraitProps) {
        super(props);
        let toolbar: IDeckToolbarSettings = { exhaust: true, zoom: false };
        if (this.props.disableToolbar) {
            toolbar = { zoom: false };
        }
        this.deckChanged = this.deckChanged.bind(this);
        this.deck = new Deck( toolbar);
    }
    onDragComplete() {
    }
    getDragItem(): any {
        return this.props.index;
    }
    dragStart(event: React.DragEvent<HTMLDivElement>) {
        event.dataTransfer.setData("text", this.props.index.toString());
        event.dataTransfer.setData(InvestigatorPortraitComponent.dragType, this.props.index.toString());
        event.dataTransfer.effectAllowed = "move";
        //const img = new Image();
        //img.src = this.props.dragImage;
        //event.dataTransfer.setDragImage(img, 50, 50);
        //TokenComponent.currentDraggedComponent = this;  
    }
    deckChanged(s: string) {
        this.props.onChanged();
    }
    componentWillMount(): void {
       
        this.deck.onChange(this.deckChanged);
    }

    componentWillUnmount(): void {
        this.deck.removeOnChange(this.deckChanged);
    }

    render() {
        this.deck.setDeck({ cards: [this.props.investigator.portrait] });
        const cssClasses = "portrait " + CardUtil.getCardCss(this.props.investigator.card, !this.props.investigator.portrait.exhausted);
        let draggable = true;
        if (this.props.disableDrag) {
            draggable = false;
        }
        return (
            <div className={cssClasses}
                draggable={draggable}
                onDragStart={(e) => { Dnd.dragStart(e, this, InvestigatorPortraitComponent.dragType, Dnd.move); }}
            >
                <CardToolbarComponent deck={this.deck} />
            </div>
        );
    }

}

